import React, { useState, useEffect, useRef, useMemo } from "react";
import ReactHtmlParser from "react-html-parser";
import { Form } from "react-bootstrap";
import "components/custom.css";
import { store, persistor } from 'store/index';
// import TagIcon1 from "assets/images/images_new/tag1.svg";
import TimeUp from "components/PracticeMaterial/PopUps/TimeUp";
import ClockIcon from "assets/images/images_new/clock_1.png";

const LIMIT = 1200; // 20 minutes.
// const LIMIT = 10; // 10 seconds. testing only.

const Essay = (props) => {
  const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(LIMIT);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [content, setContent] = useState('');
  const [lang, setLang] = useState(store.getState().user.lang);
  // const [copy, setCopy] = useState('');
  const [resultObj, setResultObj] = useState({});
  const [correctFlag, setCorrectFlag] = useState(true);
  const [timeoutStat, setTimeoutStat] = useState(false);
  const [showTimer, setShowTimer] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [inputRows, setInputRows] = useState(1);
  const [scrollHeight, setScrollHeight] = useState(0);

  const intervalIdRef = useRef(null);
  const recordIdRef = useRef(null);

  // ComponentDidMount effect
  useEffect(() => {
    console.log("Ths is essay of pratice")
    if (!props.answer) {
      intervalIdRef.current = setInterval(timer, 1000);
      const { isQuestionTime, questionTime } = props;

      if (isQuestionTime) {
        setSecondCount(questionTime * 60);
        setShowTimer(isQuestionTime);
      }
    }

    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (props.answer && intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = null;
    }
  }, [props.answer]);

  // getDerivedStateFromProps effect
  useEffect(() => {
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        clearInterval(intervalIdRef.current);
        clearInterval(recordIdRef.current);

        const { isQuestionTime, questionTime } = props;
        let secondState = { secondCount: 1200, showTimer: true };
        if (isQuestionTime) {
          secondState = {
            secondCount: questionTime * 60,
            showTimer: isQuestionTime,
          };
        }

        setTimeoutStat(false);
        setCorrectFlag(true);
        setSecondCount(secondState.secondCount);
        setShowTimer(secondState.showTimer);
        setContent('');
        setQuestionId(props.data.id);
        setReset(true);
      } else {
        if (!questionId) {
          setCorrectFlag(true);
          setQuestionId(props.data.id);
          setContent("");
        }
      }
    }
  }, [props.data, props.restart, questionId, props.isQuestionTime, props.questionTime]);

  // Reset effect
  useEffect(() => {
    if (reset) {
      const newIntervalId = setInterval(timer, 1000);
      intervalIdRef.current = newIntervalId;
      setReset(false);
    }
  }, [reset]);

  // Timer effect for answer submission
  useEffect(() => {
    if (props.answer && intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
    }
  }, [props.answer]);

  // const stopTest = () => {
  //   props.nextQuestion({ ...resultObj, time: secondCount });
  // };

  const copyToClipboard = () => {
    document.execCommand("copy");
  };

  // const cutToClipboard = () => {
  //   document.execCommand("cut");
  // };

  // const pasteToClipboard = async () => {
  //   alert("Press Ctrl+v for paste text");
  // };

  const timer = () => {
    const { answer } = props;

    // keep running timer if question is not submitted.
    if (!answer) {
      setSecondCount((prevCount) => {
        if (prevCount === 1) {
          clearInterval(intervalIdRef.current);
          setTimeoutStat(true);
          setIsOpen(true);
        }
        return prevCount - 1;
      });
    } else {
      // clear interval.
      clearInterval(intervalIdRef.current);
    }
  };

  const cleanString = (input) => {
    let output = "";
    for (let i = 0; i < input.length; i++) {
      output += input.charCodeAt(i) <= 127 ? input.charAt(i) : ' ';
    }
    return output;
  };

  // const handleTextareaSize = (e) => {
  //   if ((scrollHeight < e.target.scrollHeight)) {
  //     if (inputRows < 7) {
  //       e.target.style.height = "0px";
  //       e.target.style.height = (25 + e.target.scrollHeight) + "px";

  //       setScrollHeight(e.target.scrollHeight);
  //       setInputRows(inputRows + 1);
  //     }
  //   }
  //   else if (scrollHeight === e.target.scrollHeight) {
  //     e.target.style.height = scrollHeight + "px";
  //     e.target.style.height = (25 - e.target.scrollHeight) + "px";
  //   }
  // };
  const handleTextareaSize = (e) => {
    const textarea = e.target;

    const maxHeight = 241;

    textarea.style.height = "auto";

    if (textarea.scrollHeight > maxHeight) {
      textarea.style.height = maxHeight + "px";
      textarea.style.overflowY = "auto"; // show scrollbar
    } else {
      textarea.style.height = textarea.scrollHeight + "px";
      textarea.style.overflowY = "hidden"; // hide scrollbar
    }
  };  

  const chaneText = (e) => {
    props.showResult();
    let { name, value } = e.target;
    let clean_value = value.replace('"', '"');
    clean_value = cleanString(clean_value);

    const newResultObj = {
      answer: clean_value,
      correct: '',
      length: clean_value.split(' ').filter(function (n) { return n != '' }).length,
      time: secondCount,
      lang: lang
    };
     const hasContent = value.trim().length > 0; 
    console.log(hasContent);
    props.submit(newResultObj, hasContent);
    setContent(clean_value);
    setResultObj(newResultObj);
  };

  // const chaneLang = (e) => {
  //   setLang(e.target.value);
  // };

  // const updateCorrect = () => {
  //   const newResultObj = { 'answer': '', 'correct': '', 'length': 0, time: secondCount, lang: lang };
  //   props.submit(newResultObj);
  //   setCorrectFlag(false);
  //   setResultObj(newResultObj);
  // };

  const timeLeft = () => {
  const totalSeconds = Math.max(0, Math.floor(secondCount));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return ` ${minutes}m:${seconds.toString().padStart(2, "0")}s`
    // return `${Math.floor(secondCount / 60)}m : ${secondCount % 60}s`;
  };

  const wordCount = () => {
    return content === "" ? 0 : content.trim().split(/\s+/).length;
  };

  const toggle = () => {
    setIsOpen(!isOpen);
  };

   let questionText = useMemo(() => {
    return props.data?.question || "";
  }, [props.data?.question]);
  
  
  useEffect(() => {
    if (props.restart) {
      props.restartQue();
    }
  }, [props.restart]);


  // useEffect(() => {
  //   if (props.data) {
  //     console.log("111111");
  //     questionText = props.data.question;
  //     if (correctFlag) {
  //       updateCorrect();
  //     }
  //   }
  // }, [props.data]);

  // if (props.data) {
  //   questionText = props.data.question;
  // }

  // useEffect(() => {
  //   if (props.stopRecording) {
  //     stopTest();
  //   }
  // }, [props.stopRecording])
  // if (props.restart) {
  //   props.restartQue();
  // }
  //  if (props.stopRecording) {
  //     stopTest();
  //   }
  // if (props.data) {
  //   questionText = props.data.question;
  //   if (correctFlag) {
  //     updateCorrect();
  //   }
  // }

  function Question({ questionText }) {
  return (
    <div className="write-email" style={{ paddingLeft: "20px" }}>
      {ReactHtmlParser(questionText)}
    </div>
  );
 }

  const { resultMode, answer, showResponse } = props;

  return (
    <>
      <div className="custom-box mx-0">
        <p className="gray-text readable unselectable">
          {/* {questionText} */}
          <Question questionText={questionText} />
          </p>
      </div>

      <div className="editor-wrapper-section custom-box mx-0">
        {!resultMode && !answer && !timeoutStat ? (
          <>
            <div className="editor-wrapper">
              <div className="editor__toolbar">
                <button className="toolbar__button"></button>
              </div>
              <div className="editor__input">
                <Form.Control
                  as="textarea"
                  className="writing-textarea"
                  onCopy={copyToClipboard}
                  autoCorrect="false"
                  spellCheck="false"
                  name="content"
                  onChange={chaneText}
                  onKeyUp={handleTextareaSize}
                  value={content}
                  placeholder="Write your response here"
                />
              </div>
            </div>

            <div className="clearfix mt-3 sm-flex">
              <div className="time-spent pull-left sm-flex">
                <img src={ClockIcon} alt="Badge" /><span>Time Left:</span> {timeLeft()}
              </div>

              <div className="word-count pull-right">
                <span>Total word count:</span> {wordCount()}
              </div>
            </div>
          </>
        ) : (
          <div className="editor-wrapper">
            <div className="editor__toolbar">
              <button className="toolbar__button"></button>
            </div>
            <div className="editor__input">
              <div style={{
                whiteSpace: 'pre-line'
              }}>{content}</div>
            </div>
          </div>
        )}
      </div>
     {!answer && 
      <TimeUp
        isOpen={isOpen}
        toggle={toggle}
        title="Time up !!!"
        message="You have used up all your allotted time for this question."
        buttonLabel="Submit Now"
        showResponse={showResponse}
        allowClose={true}
        // submitDisable={content.trim().length === 0}
        submitDisable={props.submitDisable}
      />
     }
    </>
  );
};

export default Essay;